import { render, staticRenderFns } from "./SpecialitiesSelectActs.vue?vue&type=template&id=bcddfd8e&"
import script from "./SpecialitiesSelectActs.vue?vue&type=script&lang=js&"
export * from "./SpecialitiesSelectActs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports